<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1.9999999403953552,0C1.4499999403953552,0,0.9999999403953552,0.45,0.9999999403953552,1C0.9999999403953552,1,0.9999999403953552,15,0.9999999403953552,15C0.9999999403953552,15.55,1.4499999403953552,16,1.9999999403953552,16C2.549999940395355,16,2.9999999403953552,15.55,2.9999999403953552,15C2.9999999403953552,15,2.9999999403953552,1,2.9999999403953552,1C2.9999999403953552,0.45,2.549999940395355,0,1.9999999403953552,0C1.9999999403953552,0,1.9999999403953552,0,1.9999999403953552,0ZM14.999999940395355,0C14.449999940395355,0,13.999999940395355,0.45,13.999999940395355,1C13.999999940395355,1,13.999999940395355,15,13.999999940395355,15C13.999999940395355,15.55,14.449999940395355,16,14.999999940395355,16C15.549999940395356,16,15.999999940395355,15.55,15.999999940395355,15C15.999999940395355,15,15.999999940395355,1,15.999999940395355,1C15.999999940395355,0.45,15.549999940395356,0,14.999999940395355,0C14.999999940395355,0,14.999999940395355,0,14.999999940395355,0ZM9.999999940395355,2C9.999999940395355,2,6.999999940395355,2,6.999999940395355,2C6.449999940395355,2,5.999999940395355,2.45,5.999999940395355,3C5.999999940395355,3,5.999999940395355,12,5.999999940395355,12C5.999999940395355,12.55,6.449999940395355,13,6.999999940395355,13C6.999999940395355,13,9.999999940395355,13,9.999999940395355,13C10.549999940395356,13,10.999999940395355,12.55,10.999999940395355,12C10.999999940395355,12,10.999999940395355,3,10.999999940395355,3C10.999999940395355,2.45,10.549999940395356,2,9.999999940395355,2C9.999999940395355,2,9.999999940395355,2,9.999999940395355,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HorizontalDistribution',
} as DefineComponent
</script>
